"use client";

import { useEffect } from "react";
import { WebviewTenant } from '@enums/webview-tenant';
import { genericWebviewHandler, WebViewActions } from "@utils/client/webview";
import { TenantActionValue, TenantPageConfig } from "@config/webview-tenant-config";
import Cookies from 'js-cookie';

interface IWebviewParams {
  tenant?: WebviewTenant;
  tenantPage?: string;
  reserveTopMargin?: boolean;
}

export const WebviewInitializer = ({ tenant = WebviewTenant.AIRPASS, tenantPage, reserveTopMargin = true }: IWebviewParams) => {
  useEffect(() => {
    const initializeWebview = () => {
      genericWebviewHandler({
        action: WebViewActions.UPDATE_APP_BAR,
        action_value: tenantPage ? TenantPageConfig[tenant]?.[tenantPage]?.action_value : TenantActionValue[tenant]
      });
    }
    initializeWebview();
  }, [tenant, tenantPage]);

  if (reserveTopMargin && tenantPage && TenantPageConfig[tenant]?.[tenantPage]?.is_top_margin_required) {
    const raw = Cookies.get("native_header_height");
    /** Reserve space under native app bar when cookie is unset (in-app WebView). No background — parent layout (#1B1B1B + hero) shows through. */
    const paddingPx = raw && raw !== "0" ? raw : "64";
    return (
      <div
        aria-hidden
        style={{
          paddingTop: `${paddingPx}px`,
          width: "100%",
          background: "transparent",
        }}
      />
    );
  }
  return null;
}
